module.exports = __webpack_public_path__ + "img/file2.1cf5c8c.png";